import React, {useCallback, useContext, useEffect, useState} from 'react';
import {RecommendedFonts} from '~/common/fabric/CreateDesign/components/CardEditor/actions/Dropdown/RecommendedFonts/RecommendedFonts';
import {FontItem} from '~/common/fabric/CreateDesign/components/CardEditor/actions/Dropdown/FontItem/FontItem';
import {Typography} from '~library/atoms/Typography';
import './FontsMobile.sass';
import {AllFonts} from '~/common/fabric/CreateDesign/components/CardEditor/actions/Dropdown/AllFonts/AllFonts';
import {mapFabricFontToLocal} from '~/common/fabric/CreateDesign/components/CardEditor/actions/Dropdown/utils';
import {FabricContext} from '~/common/fabric/context/FabricContext';

export const FontsMobile = () => {
  const {canvas} = useContext(FabricContext);
  const [selectedValue, setSelectedValue] = useState({});
  const activeObjects = canvas?.getActiveObjects();

  useEffect(() => {
    setSelectedValue(mapFabricFontToLocal(activeObjects?.[0]));
  }, [activeObjects?.[0]]);

  const onChangeHandler = useCallback(
    (value) => {
      const activeObjects = canvas.getActiveObjects();
      setSelectedValue(value);
      activeObjects.forEach((obj) =>
        obj.set({
          fontFamily: value.family,
          fontStyle: value.style,
          fontWeight: value.weight,
        })
      );
      canvas.requestRenderAll();
      canvas.fire('object:modified');
    },
    [canvas]
  );

  return (
    <div className="fonts__mobile">
      <div className="fonts__mobile__bottom">
        <div className="fonts__mobile__bottom__selected_font">
          <FontItem font={selectedValue} selected />
        </div>

        <div className="fonts__mobile__bottom__recommended">
          <RecommendedFonts onChange={onChangeHandler} selectedFont={selectedValue} />
        </div>
        <Typography
          as="h1"
          variant="label2"
          color="pebble"
          classNames="fonts__mobile__bottom__title"
        >
          All fonts
        </Typography>
        <div className="fonts__mobile__bottom__all">
          <AllFonts onClick={onChangeHandler} selectedFont={selectedValue} />
        </div>
      </div>
    </div>
  );
};
